import React, { useState, useEffect } from 'react';
// import InputMask from 'react-input-mask';
import { Jumbotron, Table/* , FormGroup, Label, Button, Form */ } from 'reactstrap';
//import CustomSelect from '~/Components/CustomSelect';
import Waiter from '~/Components/Waiter';
import { Section } from '../styles';
// import api, { signIn } from '../../../services/api';
import PDFModal from '~/Components/PDFModal';
// import { COLORS } from '~/styles/colors';
// import Card from '~/Components/Card';
// import { useHistory } from 'react-router-dom';
import FileFtp from '~/Components/FileFtp';

/* import {
	FaInfoCircle
	// FaDownload,
} from 'react-icons/fa'; */

function FormConsultaInformacaoBasica() {
	const [modalVisivel, setModalVisivel] = useState(false);
	const [loading/* , setLoading */] = useState(false);
	// const [inscricao, setInscricao] = useState('');
	const [erro/* , setErro */] = useState('');
	const [pdfUrl/* , setPdfURL */] = useState('');

	useEffect(() => {

	}, []);

	/*async function gerarConsulta() {
		try {
			await signIn();*/
			// var ins = inscricao.replace(/[^0-9,]*/g, '').replace(',', '.');
			/*setLoading(true);
			const { data } = await api.post(
				'/cadastro/relatorios/consulta_informacoes_basicas',
				{
					inscricao: ins,
					method: 'create',
				}
			);
			if (!data?.success || !data?.report_response?.pdf_url) {
				setErro(data?.message || 'Houve um erro ao gerar documento');
			}

			setPdfURL(data.report_response.pdf_url);
			setLoading(false);
			setModalVisivel(true);
			setErro('');
		} catch (error) {
			setLoading(false);
			setErro('Houve um erro ao gerar documento');
		}
	}*/

	function closeModal() {
		setModalVisivel(false);
	}

	
		// const history = useHistory();

		let links = [
			{
				"name":"Informação Básica por Zoneamento",
				"files": [
					{
						"url":"http://www.prefeituradivinopolis.com.br/geoplantas/informacao_basica/",
						"description":"Informação Básica por Zoneamento",
						"name":"Informação Básica por Zoneamento",
						"originalName":"Informação Básica por Zoneamento",
						"ext":"ftp"
					}
				]
			}
		];

		return (
			<>
				{modalVisivel && (
					<PDFModal
						title="Consulta Informação Básica"
						closeModal={closeModal}
						pdfUrl={pdfUrl}
					/>
				)}
				<Section>
					<Jumbotron style={{ background: 'transparent' }}>
						<h1 className="display-6">Consulta Informação Básica</h1>
						<p className="lead">
							Secretaria Municipal de Planejamento e Fiscalização Urbana e Meio Ambiente
						</p>

						<Table hover>
							<tbody>
								{links.map((e, i) => (
									<FileFtp key={String(i)} data={e} />
								))}
							</tbody>
						</Table>


						{/* <Card
						backgroundColor={COLORS.bgCard1}
						textColor={COLORS.fgCard1}
						onClick={() => history.push('/media/info-basica-zoneamento')}
						icon={<FaInfoCircle size={48} color={COLORS.fgPrimary} />}
						text={['INFORMAÇÃO BÁSICA POR ZONEAMENTO']}
					/> */}


						{erro && <span style={{ color: '#ff1912' }}>{erro}</span>}
						<hr className="my-2" />
						<br />
						{/* <Form onSubmit={(e) => e.preventDefault()}>
						<FormGroup>
							<Label htmlFor="inscricao_imobiliaria">
								Inscrição imobiliária
							</Label>
							<InputMask
								type="text"
								mask="99.999.99999.99999.99999"
								className="form-control"
								name="inscricao_imobiliaria"
								id="inscricao_imobiliaria"
								placeholder="Ex: 01.001.00001.00001.00001"
								maskChar="_"
								value={inscricao}
								onChange={({ target: { value } }) =>
									setInscricao(value)
								}
							/>
						</FormGroup>
						<FormGroup>
							<Button
								onClick={gerarConsulta}
								color="info"
								type="submit"
							>
								Gerar
							</Button>
						</FormGroup>
					</Form> */}
					</Jumbotron>
					


				</Section>
				{loading && <Waiter />}


			</>

		);
	

}

export default FormConsultaInformacaoBasica;
